import type { ReviewCollectionGetResponseAnswer } from '@backmarket/http-api/src/api-specs-reviews/types/review-form'

import type { ReviewForm, ReviewFormQuestion } from '../models/review-form'

const getQuestionDefaultValue = (question: ReviewFormQuestion) => {
  if (question.type === 'rating_bar') return 0
  if (question.type === 'textarea') return ''
  if (question.type === 'file_upload') return []

  return ''
}

const getQuestionValueFromApi = (
  question: ReviewFormQuestion,
  answers: ReviewCollectionGetResponseAnswer[] = [],
) => {
  const answer = answers.find((ans) => ans.identifier === question.identifier)

  if (!answer) return getQuestionDefaultValue(question)

  if ('rate' in answer.value) return answer.value.rate

  if ('comment' in answer.value) return answer.value.comment

  if ('attachments' in answer.value) {
    //   const attachment = {
    //     url: 'https://reviews-preprod.statics.backmarket.com/preprod/review-attachement/aUU1vK4jslFB7KUhsUXipUQYD1uqyeHYiYzjGKDC50bULKebBEawpLB5wQfeAO6nBrnuCOcPNmolYZGd1yHdqhiTMmWO/original.jpegImage preview',
    //     uploadId:
    //       'aUU1vK4jslFB7KUhsUXipUQYD1uqyeHYiYzjGKDC50bULKebBEawpLB5wQfeAO6nBrnuCOcPNmolYZGd1yHdqhiTMmWO',
    //     fileName: 'IMG_7896',
    //   }
    //   const dataTransfer = new DataTransfer()

    //   // answer.value.attachments.forEach((attachment) => {
    //   const file = new File([attachment.fileName], attachment.url, {
    //     type: 'image/jpeg',
    //   })
    //   dataTransfer.items.add(file)
    //   // })

    //   console.log('dataTransfer', dataTransfer)

    //   return dataTransfer.files
    return []
  }

  return ''
}

export function buildReviewForm(
  questions: ReviewFormQuestion[],
  form: ReviewForm | undefined,
  apiAnswers: ReviewCollectionGetResponseAnswer[],
) {
  // this is necessary to maintain state when going back to a previous step
  const previousStepValues = form || {}

  const reviewForm: ReviewForm<ReviewFormQuestion[]> = {}

  questions.forEach((question) => {
    const formValue = form ? form[question.identifier] : null
    const apiValue = getQuestionValueFromApi(question, apiAnswers)
    reviewForm[question.identifier] = formValue || apiValue
  })

  return {
    ...previousStepValues,
    ...reviewForm,
  }
}
